// 🔧 categories.js
// ✅ Purpose: Car Show category template for the LGV Seed Engine
// ✅ Features:
// - Defines realistic categories for seeded car show events
// - Keeps industry content separate from generator logic
// - Supports future expansion and customization
// - Future-ready for AI-generated category suggestions
// - Fully block-commented for clarity and future devs

export const CAR_SHOW_CATEGORIES = [
  {
    name: "Classic Cars",
    description:
      "Restored and preserved vehicles from earlier automotive eras.",
  },

  {
    name: "Muscle Cars",
    description:
      "High-performance American classics known for power and presence.",
  },

  {
    name: "Trucks",
    description:
      "Classic, custom, lifted, lowered, and restored trucks.",
  },

  {
    name: "Imports",
    description:
      "Imported vehicles featuring performance and styling.",
  },

  {
    name: "European",
    description:
      "European vehicles showcasing engineering and design.",
  },

  {
    name: "Modern Performance",
    description:
      "Late-model performance vehicles and sports cars.",
  },

  {
    name: "Best Paint",
    description:
      "Outstanding paint quality and finish.",
  },

  {
    name: "Best Interior",
    description:
      "Interior craftsmanship and presentation.",
  },

  {
    name: "Best Engine",
    description:
      "Engine bay appearance and detailing.",
  },
];